<!--
    @日常办公 原工作人员角色
-->
<template>
    <div class="daily_main">
        <!-- <el-card class="top_fun" shadow="never">
            <dailyofficeTop></dailyofficeTop>
        </el-card>
        <div class="daily_main--con">
            <el-row :gutter="24" class="middle_matter">
                <el-col :span="16">
                    <dailyofficeCenter></dailyofficeCenter>
                </el-col>
                <el-col :span="8">
                    <dailyofficeNotice></dailyofficeNotice>
                </el-col>
            </el-row>
            <el-row :gutter="24" class="bottom_matter">
                <el-col :span="16">
                    <dailyofficeToday></dailyofficeToday>
                </el-col>
                <el-col :span="8">
                    <dailyofficeQuick></dailyofficeQuick>
                </el-col>
            </el-row>
        </div> -->
        <el-row :gutter="24" class="content">
            <el-col :span="18" style="height: 100%;">
                <!-- 统计 -->
                <Statistics></Statistics>
                <!-- 待办事项 -->
                <Dealt></Dealt>
                <!-- 今日开标 -->
                <div class="common-card open">
                    <div class="card-title">
                        <p>开评标视频见证</p>
                        <div class="open-title--right">
<!--                            <el-select class="select">-->
<!--                                <el-option value="1" label="市本级1"></el-option>-->
<!--                                <el-option value="2" label="市本级2"></el-option>-->
<!--                            </el-select>-->
<!--                            <el-input class="input" placeholder="请输入项目编号/名称">-->
<!--                                <i slot="suffix" class="el-input__icon el-icon-search"></i>-->
<!--                            </el-input>-->
                            <div class="worship" v-for="(item,index) in dataList" :key="index" :class="item.class">
                                <div>{{dayToday}} {{item.text}}</div>
                                <div><span class="ancestor">{{todayData[item.key] || 0}}</span>宗</div>
                            </div>
                        </div>
                    </div>
                    <div class="common-content">
                        <div class="open-content hidden-content">
                            <div class="open-left">
<!--                                <div class="open-statistics">-->
<!--                                    <div class="open-statistics&#45;&#45;item" v-for="(item,index) in dataList" :key="index" :class="item.class">-->
<!--                                        <div class="number">-->
<!--                                            <span>{{todayData[item.key] || 0}}</span>宗-->
<!--                                        </div>-->
<!--                                        <div class="title">{{dayToday}} {{item.text}}</div>-->
<!--                                    </div>-->
<!--                                </div>-->
                                <div class="open-calendar hidden-content scroll_hidden">
                                    <CalendarCom @on-caledar="caledarHandler"></CalendarCom>
                                </div>
                            </div>
                            <div class="open-right hidden-content scroll_hidden" @mouseover="mymouseIn" @mouseout="mymouseOut" v-loading="loading">
                                <div class="no-message" v-if="todayList.length === 0">
                                    <img :src="`${require('@/assets/images/nomessage.png')}`" alt="">
                                    <p>暂无项目</p>
                                </div>
                                <template v-else>
                                    <OpenItem
                                        class="open-item"
                                        v-for="item in todayList"
                                        :key="item.bidId"
                                        :item="item"
                                    ></OpenItem>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6" style="height: 100%;">
                <!-- 通知消息 -->
                <Notice></Notice>
                <!-- 日程管理 -->
                <Outlook></Outlook>
                <!-- 便捷入口 -->
                <Quick></Quick>
            </el-col>
        </el-row>
    </div>
</template>

<script>
// import dailyofficeTop from './daily-office/daily-office-top.vue';
// import dailyofficeNotice from './daily-office/daily-office-notice.vue';
// import dailyofficeToday from './daily-office/daily-office-today.vue';
// import dailyofficeQuick from './daily-office/daily-office-quick.vue';
// import dailyofficeCenter from './daily-office/daily-office-center.vue';
import Statistics from './new/Statistics.vue';
import Outlook from './new/Outlook.vue';
import CalendarCom from './new/CalendarCom.vue';
import Dealt from './new/Dealt.vue';
import OpenItem from './new/OpenItem.vue';
import Notice from './new/Notice.vue';
import Quick from './new/Quick.vue';
import dayjs from '@/utils/dayjs.js';
import {
    apiFieldApplyBaseFieldapplybaseQueryBidTodayCount,
    apiFieldApplyBaseFieldapplybaseQueryBidTodayList
} from '@/server/new.js';
export default {
    props:["mainContentViewHeight"],
    components:{
        // dailyofficeTop,
        // dailyofficeNotice,
        // dailyofficeToday,
        // dailyofficeQuick,
        // dailyofficeCenter
        Statistics,
        Outlook,
        CalendarCom,
        Dealt,
        OpenItem,
        Notice,
        Quick
    },
    computed:{},
    mounted(){
        this.apiFieldApplyBaseFieldapplybaseQueryBidTodayCount();
        this.apiFieldApplyBaseFieldapplybaseQueryBidTodayList();
    },
    data(){
        return {
            today: dayjs(new Date()).format('YYYY-MM-DD'),
            dayToday: dayjs(new Date()).format('MM-DD'),
            dataList: [
                {text: '待开标见证数量',class:null,key:'bidopenCount'},
                {text: '待评标见证数量',class:'open-statistics--item--orange',key:'evalCount'}
            ],
            todayData: {},
            todayList: [],
            loading: false
        }
    },
    methods:{
        apiFieldApplyBaseFieldapplybaseQueryBidTodayCount(data) { //获取开评标数量
            if (data) {
                this.today = data;
                this.dayToday = dayjs(data).format('MM-DD')
            }
            apiFieldApplyBaseFieldapplybaseQueryBidTodayCount(this.today).then(({data}) => {
                this.todayData = data.data;
            })
        },
        caledarHandler(data) {
            this.apiFieldApplyBaseFieldapplybaseQueryBidTodayList(data);
            this.apiFieldApplyBaseFieldapplybaseQueryBidTodayCount(data);
        },
        apiFieldApplyBaseFieldapplybaseQueryBidTodayList(data) { //获取今日开标列表
            this.loading = true;
            apiFieldApplyBaseFieldapplybaseQueryBidTodayList({
                date: data || this.today,
                tradeId: this.$store.state.user.supperAdmin?'':this.$store.state.user.orgId ||''
            }).then(({data}) => {
                this.todayList = data.data || [];
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>

<style lang="less" scoped>
// @import "@/assets/scss/home-center.scss";
.daily_main{
    // width: 100%;
    width: calc(100% - 48px);
    height: calc(100% - 48px);
    min-width: 1400px;
    position: absolute;
    color: rgba(0, 0, 0, 0.85);
    // margin-top: 10px;
    .content {
        height: 100%;
    }
    // .el-col{
    //     height: 100%;
    // }
    // .top_fun{
    //     /deep/ .el-card__body{
    //         padding: 0;
    //     }
    // }
    // .daily_main--con{
    //     margin: 20px 20px 0;
    //     height: calc(100% - 124px - 20px);
    //     .middle_matter{
    //         height: 50%;
    //     }
    //     .bottom_matter{
    //         height: calc(50% - 20px);
    //         margin-top: 20px;
    //     }
    // }
    .open {
        margin-top: 24px;
        height: calc(50% - 79px);
        .card-title {
            .btn {
                margin-left: 10px;
            }
            .open-title--right {
                margin-left: auto;
                display: flex;
                .select {
                    width: 150px;
                }
                .input {
                    width: 200px;
                    margin-left: 10px;
                }
            }
        }
        .open-content {
            display: flex;
            justify-content: space-between;
            //padding: 16px 10px 16px 16px;
            .open-left {
                width: 500px;
                height: 100%;
                //display: flex;
                //flex-direction: row;
                //background-color: slateblue;
                margin-right: 10px;
                .open-statistics {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    .open-statistics--item {
                        border: 1px solid #E8E8E8;
                        border-radius: 4px;
                        padding: 7px 34px 8px;
                        .number {
                            font-size: 12px;
                            font-weight: 400;
                            color: #2568EC;
                            text-align: center;
                            span {
                                font-size: 32px;
                                line-height: 38px;
                                margin-right: 4px;
                            }
                        }
                        .title {
                            font-weight: 400;
                            color: #000000;
                            line-height: 16px;
                            margin-top: 8px;
                        }
                        &.open-statistics--item--orange {
                            .number {
                                color: #FF9900;
                            }
                        }
                    }
                }
                .open-calendar {
                    // height: calc(100% - 79px);
                    height:100%;
                    // border: 1px solid #E8E8E8;
                    border-radius: 4px;
                    //margin-top: 10px;
                    overflow: auto;
                }
            }
            .open-right {
                flex: 1;
                height: 100%;
                padding-right: 10px;
                display: flex;
                flex-wrap: wrap;
            }
        }
    }
    .notice,.outlook,.quick {
        // height: calc(100% / 2 - (12px) * 1 / 2 );
        height: calc(100% / 3 - (24px) * 2 / 3);
        margin-bottom: 24px;
    }
    .quick {
        margin-bottom: 0;
    }


}
.worship{
    display: flex;
    align-items: center;
    margin-left: 10px;
    >div{
        display: flex;
        align-items: center;
    }
    .ancestor{
        display: flex;
        align-items: center;
        text-align: center;
        background-color: #2568EC;
        border-radius: 100%;
        width: 18px;
        height: 18px;
        color: #ffffff;
        justify-content: center;
        font-size: 12px;
        margin: 0 3px;
    }
    &.open-statistics--item--orange .ancestor{
        background-color: #FF9900;
    }
}
</style>
